import { useMemo } from "react";

import { useGetFeatureSubscriptionsQuery } from "services/paywall";

const useAmbientScribeTrialStatus = () => {
  const { data: featureSubscriptions, isFetching: isFetchingSubscriptions } =
    useGetFeatureSubscriptionsQuery({});

  const isTrialExpired = useMemo(() => {
    return Boolean(
      featureSubscriptions?.some(
        (sub: any) =>
          sub.feature.feature_key === "ambient_scribe_users" &&
          Boolean(sub.trial_end) &&
          new Date(sub.trial_end) < new Date()
      )
    );
  }, [featureSubscriptions]);

  return { isTrialExpired, isFetchingSubscriptions };
};

export default useAmbientScribeTrialStatus;
